<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/home">Home</a></li>
                <li><a routerLink="/courses-category">Course Category</a></li>
                <li>Courses</li>
                <li>{{ coursesData[0]?.coursesName }}</li>
            </ul>
            <h2>{{ coursesData[0]?.coursesName }}</h2>
        </div>
    </div>
    <div class="shape9"><img src="images/shape8.svg" alt="image"></div>
</div>

<div class="courses-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="courses-details-image-style-two text-center">
                    <img [src]="imageUrl+coursesData[0]?.imagePath" alt="image">
                </div>
                <div class="courses-details-desc-style-two">
                    <div [innerHTML]="safeDescription"></div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="courses-sidebar-information courses-details-info">
                    @if (coursesData[0]?.youtubeLink) {
                    <div class="image">
                        <img src="images/course1.jpg" alt="image">
                        <div class="content" (click)="openPopup(coursesData[0]?.youtubeLink)">
                            <i class="fa-solid fa-play"></i>
                            <span>Course Preview</span>
                        </div>
                    </div>
                    }
                    <ul class="info">
                        <li class="price">
                            <div class="d-flex justify-content-between align-items-center">
                                <span><i class="fa-solid fa-money-bill-1 mt-1"></i>Fees</span>
                                ₹{{coursesData[0]?.fees}}
                            </div>
                        </li>
                        <li>
                            <div class="d-flex justify-content-between align-items-center">
                                <span><i class="fa-solid fa-hourglass-start mt-1"></i> Duration</span>
                                {{coursesData[0]?.duration}}
                            </div>
                        </li>
                        <li>
                            <div class="d-flex justify-content-between align-items-center">
                                <span><i class="fa-solid fa-user-graduate mt-1"></i> Eligibility</span>
                                {{coursesData[0]?.eligibility}}
                            </div>
                        </li>
                    </ul>
                    <div class="btn-box">
                        <a class="default-btn animate-pulse" (click)="applyForAdmission()"><i
                                class="flaticon-tag"></i>Inquiry
                            Now<span></span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="video-popup position-fixed d-flex align-items-center justify-content-center text-center top-0 start-0 end-0 bottom-0"
    *ngIf="isOpen">
    <div class="popup-inner bg-white position-relative mx-auto">
        <iframe [src]="safeYoutubeUrl" title="Web Design Trends 2025" frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <button (click)="closePopup()" type="button"
            class="close-btn p-0 border-0 d-flex align-items-center justify-content-center rounded-circle">
            <i class="fa-solid fa-xmark"></i>
        </button>
    </div>
</div>